module.exports = __webpack_public_path__ + "d20d3e0cf1bec347594d0a88b8f40c6a.svg";